import { inventory } from "@/common/ads";

const display = slot => {
    if (typeof window.__PRERENDER_INJECTED === "undefined" && typeof slot === "object") {
        window.ads[slot.dom_id] = null;
        AdBridg.cmd.push(slot);
        AdBridg.cmd.push(function() {
            AdBridg.display(slot.dom_id);
        });
    }
};

const destroy = slot => {
    if (
        typeof window.__PRERENDER_INJECTED === "undefined" &&
        typeof slot === "object" &&
        window.ads[slot.dom_id] !== null
    ) {
        AdBridg.destroySlots([window.ads[slot.dom_id]]);
        delete window.ads[slot.dom_id];
    }
};

export default {
    name: "Advertising",
    props: {
        id: {
            type: String
        }
    },
    computed: {
        slot() {
            if (typeof inventory[this.id] === "undefined") {
                return false;
            }
            return inventory[this.id];
        }
    },
    mounted() {
        this.$nextTick(() => {
            display(this.slot);
        });
    },
    beforeUpdate() {
        this.$nextTick(() => {
            destroy(this.slot);
        });
    },
    updated() {
        this.$nextTick(() => {
            display(this.slot);
        });
    },
    beforeDestroy() {
        this.$nextTick(() => {
            destroy(this.slot);
        });
    }
};



// WEBPACK FOOTER //
// ./src/components/Advertising/Advertising.js